import { render, staticRenderFns } from "./icon_item.vue?vue&type=template&id=93a406a8&scoped=true&"
import script from "./icon_item.vue?vue&type=script&lang=js&"
export * from "./icon_item.vue?vue&type=script&lang=js&"
import style0 from "./icon_item.vue?vue&type=style&index=0&id=93a406a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a406a8",
  null
  
)

export default component.exports